/**
 * @generated SignedSource<<365054cfbb828b5c28ba02ef519e1bcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateAuthorRelayFragment$data = {
  readonly contributor: {
    readonly __typename: "ContentPlatformAuthor";
    readonly jobTitle: string | null | undefined;
    readonly name: string | null | undefined;
    readonly organization: {
      readonly name: string | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "ContentPlatformOrganization";
    readonly name: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "templateAuthorRelayFragment";
};
export type templateAuthorRelayFragment$key = {
  readonly " $data"?: templateAuthorRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateAuthorRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateAuthorRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "contributor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentPlatformOrganization",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "type": "ContentPlatformAuthor",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "ContentPlatformOrganization",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "d3e74586e4b920a27abe98ecbb767f31";

export default node;
